<template>
  <modal name="row-specification-modal"
         @closed="$emit('updateComparisonData')"
         @before-close="beforeClose"
         @before-open="beforeOpen"
         style="z-index: 1001;">
    <div id="modal-header" class="w-100 px-4 py-2 position-relative"
         style="background-color:#1e7bb7">
      <div class="w-100 d-flex">
        <div class="row justify-content-center">
          <div class="col-12">
            <h4 class="text-white text-center">Տեխնիկական բնութագիր</h4>
          </div>
          <!-- <div class="col-10">
            <h6 class="text-white text-center">{{ tender.name }}</h6>
          </div> -->
        </div>
      </div>
      <button type="button"
              class="close position-absolute"
              style="right: 1.25rem; top: 30%"
              @click="$modal.hide('row-specification-modal')" aria-label="Close">
        <span aria-hidden="true" class="text-white">&times;</span>
      </button>
    </div>
    <div id="modal-body" class="p-4" style="overflow-x: auto; height: 85%">
      <span>
        {{row.specifications}}
      </span>
    </div>
  </modal>
</template>
<script>

export default {
  name: 'RowSpecificationModal',
  data () {
    return {
      row: {},
    }
  },
  computed: {
    me() {
      return this.$store.getters['user/me']
    },
  },
  methods: {
    consoleLog(data){
      console.log(data)
    },
    beforeClose(){
      this.row = {};
    },
    beforeOpen({params}){
      this.row = params
      console.log(this.row)
    },
  }
}
</script>
<style scoped>
  /deep/ .vm--modal {
    top: 0 !important;
    bottom: 0 !important;
    right: 0 !important;;
    left: 0 !important;;
    margin: auto;
    position: absolute;
    overflow: inherit !important;
    width: 40% !important;
    height: 60% !important;
    padding-bottom: 0px;
    -webkit-border-radius: .3rem !important;
    -moz-border-radius: .3rem !important;
    border-radius: .3rem !important;
  }
  .searchItem:hover {
    background-color: #1e7bb7;
    color: #fff;
  }
  .component-fade-enter-active, .component-fade-leave-active {
    transition: opacity .2s ease;
  }
  .component-fade-enter, .component-fade-leave-to
    /* .component-fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
</style>

